import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslocoModule } from '@jsverse/transloco';
import { IconsModule } from 'src/app/icons/icons.module';
import { ErrorDialogModule } from 'src/app/components/error-dialog/error-dialog.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { BaseImageDetailPopupComponent } from './base-image-detail-popup.component';
import { EnvironmentTableModule } from '../../environment-table/environment-table.module';
import { EnvironmentPaginatorrModule } from '../../environment-paginator/environment-paginator.module';

@NgModule({
  declarations: [BaseImageDetailPopupComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatDividerModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    TranslocoModule,
    IconsModule,
    ErrorDialogModule,
    TitleCasePipe,
    EnvironmentTableModule,
    EnvironmentPaginatorrModule,
    SearchFilterModule
  ]
})
export class BaseImageDetailPopupModule {}
